import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDocumentDatabaseService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-document-database-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.5 4.232 3.02 6.821l-.01 5.169L3 17.159l.15.094c.082.051 2.107 1.224 4.5 2.604L12 22.368l4.35-2.511c2.392-1.38 4.418-2.553 4.5-2.604l.15-.094-.01-5.169-.01-5.169-4.48-2.589A679 679 0 0 0 12 1.643c-.011 0-2.036 1.165-4.5 2.589m8.223 1.286 3.737 2.157v8.654l-3.73 2.154L12 20.636l-3.73-2.153-3.73-2.154V7.676l3.72-2.154 3.723-2.158c.002-.002 1.685.967 3.74 2.154m-4.119-.148c-1.688 1.161-2.986 3.343-3.279 5.51-.204 1.504.02 2.993.597 3.978.482.825 1.256 1.463 2.088 1.724l.23.073V19h1.519l.01-1.165.011-1.164.32-.109c.614-.209.977-.443 1.444-.93.76-.792 1.116-1.777 1.198-3.312.095-1.77-.583-3.801-1.79-5.366a11 11 0 0 0-.651-.75c-.343-.357-1.204-1.126-1.256-1.122-.014.001-.212.13-.441.288m.64 1.9a7.36 7.36 0 0 1 1.922 3.77c.082.459.07 1.694-.021 2.12-.185.863-.573 1.488-1.117 1.8a1.6 1.6 0 0 1-.238.12c-.017 0-.03-1.143-.03-2.54V10h-1.52v2.52c0 1.437-.015 2.52-.035 2.52-.082 0-.539-.342-.677-.505-.5-.595-.717-1.253-.757-2.296a6.4 6.4 0 0 1 .309-2.32c.161-.504.62-1.413.939-1.859.249-.348.877-1.06.935-1.06.015 0 .146.122.29.27"
    })
  }));
});
export default SvgDocumentDatabaseService;